import { Modal } from 'antd'
import { Helmet } from 'react-helmet'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { deleteDoc, doc, serverTimestamp, setDoc } from 'firebase/firestore/lite'
import { firestore } from 'config/Firebase'

import one from 'assets/portfolio/one.png'
import one1 from 'assets/portfolio/one1.png'
import three from 'assets/portfolio/final.png'
import final from 'assets/portfolio/final1.png'
import five from 'assets/portfolio/text-to-speech.png'
import five1 from 'assets/portfolio/text-to-speech1.png'
import eventWave1 from 'assets/portfolio/eventwave1.png'
import eventWave from 'assets/portfolio/eventwave.png'
import airtalx from 'assets/portfolio/airtalx.png'
import airtalxLong from 'assets/portfolio/airtalx_long.png'
import bmc from 'assets/portfolio/bmc.png'
import humi from 'assets/portfolio/humi.png'
import humiLogo from 'assets/portfolio/humi_logo.png'
import bmcLong from 'assets/portfolio/bmc_long.png'
import creatorApp from 'assets/portfolio/creator_app.png'
import caFeed from 'assets/portfolio/Creator_app/feed.png'
import caCampaigns from 'assets/portfolio/Creator_app/campaigns.png'
import caJobs from 'assets/portfolio/Creator_app/jobs.png'
import caProducts from 'assets/portfolio/Creator_app/products.png'
import caScriptWriter from 'assets/portfolio/Creator_app/script_writer.png'
import caMore from 'assets/portfolio/Creator_app/more.png'

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined'
import FavoriteIcon from '@mui/icons-material/Favorite'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const projects = [
  {
    id: 6,
    title: 'React Native App',
    desc: 'All-in-one platform for TikTok creators',
    thumb: creatorApp,
    images: [caFeed, caCampaigns, caJobs, caProducts, caScriptWriter, caMore],
    link: null,
    isNew: true,
    name: 'Brands Meet Creators - Creator App',
  },
  {
    id: 1,
    title: 'Brands Meet Creators',
    desc: 'TikTok affiliate marketing platform',
    thumb: bmc,
    preview: bmcLong,
    link: 'https://shop.brandsmeetcreators.com/creator/dashboard/home',
    isNew: true,
    name: 'brands-meet-creators',
  },
  {
    id: 7,
    title: 'Humis Frozen Foods',
    desc: 'Fast-growing frozen food brand',
    thumb: humi,
    preview: humiLogo,
    link: 'https://humisfrozenfoods.com',
    isNew: true,
    name: 'humis-frozen-foods',
  },
  {
    id: 0,
    title: 'AirtalX',
    desc: 'Platform for employers and job seekers',
    thumb: airtalx,
    preview: airtalxLong,
    link: 'https://airtalx.com/',
    isNew: false,
    name: 'airtalX',
  },
  {
    id: 2,
    title: 'Event Wave',
    desc: 'Platform for organizers and attendees',
    thumb: eventWave1,
    preview: eventWave,
    link: 'https://eventwawe.vercel.app/',
    isNew: false,
    name: 'event-wave',
  },
  {
    id: 3,
    title: 'Furniture Website',
    desc: 'Online store for furniture',
    thumb: one,
    preview: one1,
    link: 'https://furniture-site-6254.web.app/',
    isNew: false,
    name: 'furniture-site',
  },
  {
    id: 4,
    title: 'Trend Trove',
    desc: 'Online fashion e-commerce store',
    thumb: three,
    preview: final,
    link: 'https://trend-troove.web.app/',
    isNew: false,
    name: 'trend-trove',
  },
  {
    id: 5,
    title: 'Speech to Text',
    desc: 'Tool for converting speech to text',
    thumb: five,
    preview: five1,
    link: 'https://voice-into-text.surge.sh/',
    isNew: false,
    name: 'voice-into-text',
  },
]

export default function Portfolio() {
  const [selectedProject, setSelectedProject] = useState(null)
  const [favorites, setFavorites] = useState({})
  const [loading, setLoading] = useState({ status: false, id: null })

  useEffect(() => {
    const arr = JSON.parse(localStorage.getItem('favrt')) || []
    const map = {}
    arr.forEach((item) => { map[item.id] = true })
    setFavorites(map)
  }, [])

  const openModal = (project) => {
    setSelectedProject(project)
  }

  const handleFavorite = async (project) => {
    const arr = JSON.parse(localStorage.getItem('favrt')) || []
    const alreadyFav = arr.some((item) => item.id === project.id)

    if (alreadyFav) {
      const existing = arr.find((item) => item.id === project.id)
      setLoading({ status: true, id: project.id })
      await deleteDoc(doc(firestore, 'favrt', existing.userId?.toString()))
      setLoading({ status: false, id: null })
      const filtered = arr.filter((item) => item.id !== project.id)
      localStorage.setItem('favrt', JSON.stringify(filtered))
      setFavorites((prev) => ({ ...prev, [project.id]: false }))
      toast.success('Removed from favorites!')
    } else {
      const data = {
        userId: Math.floor(100000 + Math.random() * 900000),
        id: project.id,
        name: project.name,
        link: project.link,
        date: serverTimestamp(),
      }
      arr.push(data)
      localStorage.setItem('favrt', JSON.stringify(arr))
      setLoading({ status: true, id: project.id })
      try {
        await setDoc(doc(firestore, 'favrt', data.userId?.toString()), data)
        toast.success('Added to favorites!')
      } catch (e) {
        console.error(e)
      }
      setLoading({ status: false, id: null })
      setFavorites((prev) => ({ ...prev, [project.id]: true }))
    }
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Usman Arif | Portfolio</title>
        <meta name="description" content="Muhammad Usman Arif | My Projects & Portfolio" />
        <meta name="keywords" content="usmanarif, Muhammad Usman Arif, portfolio, projects" />
      </Helmet>

      <div id="portfolio-section" data-aos="fade-left">
        <div className="section-heading">
          <span className="section-tag">What I've Built</span>
          <h2>My <span className="gradient-text">Portfolio</span></h2>
          <div className="heading-bar" />
        </div>

        <div className="portfolio-grid pb-5 pb-md-4">
          {projects.map((project) => (
            <div className="portfolio-card" key={project.id}>
              {project.isNew && <div className="new-ribbon">New</div>}

              <div
                className="card-img-inner"
                onClick={() => openModal(project)}
                style={{ cursor: 'pointer' }}
              >
                <img src={project.thumb} alt={project.title} />
                <div className="card-img-overlay">
                  <button
                    className="overlay-btn"
                    title="Preview"
                  >
                    <VisibilityOutlinedIcon fontSize="small" />
                  </button>
                  <button
                    className={`overlay-btn${favorites[project.id] ? ' favorited' : ''}`}
                    title="Favorite"
                    onClick={(e) => { e.stopPropagation(); handleFavorite(project) }}
                    disabled={loading.status && loading.id === project.id}
                  >
                    {loading.status && loading.id === project.id ? (
                      <div className="spinner-border spinner-border-sm" style={{ width: 14, height: 14 }} />
                    ) : favorites[project.id] ? (
                      <FavoriteIcon fontSize="small" />
                    ) : (
                      <FavoriteBorderOutlinedIcon fontSize="small" />
                    )}
                  </button>
                </div>
              </div>

              <div className="card-info">
                <h6 className="card-title-text">{project.title}</h6>
                <p className="card-desc">{project.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <Modal
          centered
          width={1200}
          open={!!selectedProject}
          onOk={() => setSelectedProject(null)}
          onCancel={() => setSelectedProject(null)}
          footer={null}
          styles={{
            content: {
              background: 'var(--bg-surface)',
              border: '1px solid var(--border)',
              borderRadius: 16,
            },
            mask: { backdropFilter: 'blur(4px)' },
          }}
        >
          {selectedProject && (
            <div style={{ paddingTop: '0.5rem' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '1rem',
                  flexWrap: 'wrap',
                  gap: '0.5rem',
                }}
              >
                <span
                  style={{
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: 2,
                    color: 'var(--accent)',
                  }}
                >
                  {selectedProject.title}
                </span>
                {selectedProject.link && (
                  <Link
                    to={selectedProject.link}
                    target="_blank"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.4rem',
                      color: 'var(--accent-light)',
                      textDecoration: 'none',
                      fontSize: '0.875rem',
                      fontWeight: 600,
                    }}
                  >
                    Open Live Site <OpenInNewIcon fontSize="small" />
                  </Link>
                )}
              </div>
              {selectedProject.images ? (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: '0.75rem',
                  }}
                >
                  {selectedProject.images.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt={`${selectedProject.title} screenshot ${i + 1}`}
                      style={{
                        width: '100%',
                        borderRadius: 10,
                        border: '1px solid var(--border)',
                        objectFit: 'cover',
                      }}
                    />
                  ))}
                </div>
              ) : (
                <img
                  src={selectedProject.preview}
                  className="img-fluid"
                  alt="Preview"
                  style={{ borderRadius: 10, border: '1px solid var(--border)' }}
                />
              )}
            </div>
          )}
        </Modal>
      </div>
    </>
  )
}
